import SvgIcon from "@mui/material/SvgIcon";

export const ArithmeticIcon = () => {
	return (
		<SvgIcon viewBox={"0 0 21 21"} sx={{ padding: "2px 0px 0px 3px" }}>
			<path
				className="cls-1"
				d="M2,18c-.55,0-1.02-.2-1.41-.59-.39-.39-.59-.86-.59-1.41V2C0,1.45.2.98.59.59c.39-.39.86-.59,1.41-.59h14c.55,0,1.02.2,1.41.\
				59s.59.86.59,1.41v14c0,.55-.2,1.02-.59,1.41-.39.39-.86.59-1.41.59H2ZM2,16h14V2L2,16ZM11.5,13h-1.25c-.22,0-.4-.07-.54-.21-.14\
				-.14-.21-.32-.21-.54s.07-.4.21-.54c.14-.14.32-.21.54-.21h1.25v-1.25c0-.22.07-.4.21-.54s.32-.21.54-.21.4.07.54.21.21.32.21.54v1\
				.25h1.25c.22,0,.4.07.54.21s.21.32.21.54-.07.4-.21.54-.32.21-.54.21h-1.25v1.25c0,.22-.07.4-.21.54s-.32.21-.54.21-.4-.07-.54-.21-\
				.21-.32-.21-.54v-1.25ZM7.25,5.5c.22,0,.4-.07.54-.21s.21-.32.21-.54-.07-.4-.21-.54-.32-.21-.54-.21h-3.5c-.22,0-.4.07-.54.21s-.21.\
				32-.21.54.07.4.21.54.32.21.54.21h3.5Z"
			/>
		</SvgIcon>
	);
};

type ChargeBackIconProps = {
	color: string;
};
export const ChargeBackIcon = ({ color }: ChargeBackIconProps) => {
	return (
		<SvgIcon viewBox="0 0 19.63 21" sx={{ padding: "2px 1px 0px 0px", color }}>
			<g id="Layer_1-2">
				<g id="Layer_2-2">
					<g id="Layer_1-2">
						<path
							className="cls-1"
							d="M10.13,18c-.15-.04-.31-.03-.46-.05-2.09-.24-3.89-1.11-5.4-2.59-.35-.34-.36-.9-.02-1.26,0,0,0,0,.01-.01.34-.35\
							.91-.35,1.26,0,1.03,1.02,2.24,1.69,3.66,1.97,1.89.38,3.67.07,5.31-.97,1.79-1.14,2.88-2.77,3.25-4.86.38-2.17-.15-4\
							.13-1.54-5.84-1.15-1.41-2.66-2.24-4.45-2.53-3.45-.56-6.83,1.49-7.94,4.81q-.04.12.09.12c.26,0,.52,0,.78,0,.46.02.\
							83.4.83.87,0,.16-.04.31-.13.45-.62,1.06-1.24,2.11-1.85,3.16-.35.6-1.18.6-1.54,0-.62-1.06-1.24-2.11-1.86-3.17-.05-\
							.09-.07-.19-.12-.29v-.31s.02-.02.02-.04c.13-.44.44-.67.9-.67.3,0,.61,0,.91,0,.04,0,.08,0,.09-.06.09-.39.22-.77.37-1\
							.14.67-1.62,1.72-2.94,3.15-3.96C6.77.72,8.25.18,9.87.03c.09,0,.18,0,.26-.03h.49c.12.03.25.03.37,0h.14s.05.02.07\
							.02c.63.04,1.25.14,1.86.32,2.11.61,3.79,1.82,5.02,3.63.87,1.28,1.37,2.7,1.52,4.25,0,.1,0,.19.03.29v1.08s-.02.05-\
							.02.07c-.02.17-.03.35-.06.52-.18,1.37-.63,2.65-1.42,3.8-1.69,2.46-4.03,3.79-7,4.02h-.12c-.11,0-.22-.02-.33.01h-.55Z"
						/>
						<path
							className="cls-1"
							d="M10.21,12.53v-.2c0-.9,0-1.79,0-2.69,0-.08-.02-.11-.1-.13-.49-.14-.98-.3-1.43-.55-.71-.41-1.11-1.02-1.18-1.84-\
							.04-.47,0-.93.19-1.37.29-.68.81-1.1,1.49-1.34.29-.1.6-.17.91-.2.1,0,.13-.04.12-.14,0-.26,0-.52,0-.78,0-.25.16-.42\
							.39-.42s.39.17.39.42c0,.27,0,.54,0,.81,0,.06.02.08.08.09.43.04.87.12,1.25.33.67.36,1.12.91,1.31,1.66.09.35-.01.65-\
							.31.86-.28.2-.59.21-.89.05-.22-.11-.32-.32-.38-.55-.07-.27-.19-.51-.38-.71-.19-.19-.41-.31-.68-.39v.1c0,.82,0,1.\
							65,0,2.47,0,.08.03.1.09.12.47.13.95.26,1.39.46,1.01.46,1.6,1.52,1.47,2.64-.11.9-.52,1.61-1.29,2.09-.41.26-.88.39-\
							1.35.47-.07.01-.15.02-.22.03-.06,0-.09.03-.08.09,0,.28,0,.56,0,.84,0,.22-.17.39-.39.39-.07,0-.15-.02-.21-.06-.13\
							-.08-.19-.2-.19-.34,0-.28,0-.56,0-.83,0-.06-.01-.08-.08-.09-.59-.06-1.14-.22-1.63-.56-.63-.43-1.07-.99-1.22-1.74-\
							.03-.14-.04-.28-.03-.42.01-.31.25-.61.56-.71.33-.11.71-.01.91.23.06.07.1.15.13.24.08.24.16.49.27.73.21.49.58.79\
							,1.1.95ZM10.99,11.17c0,.44,0,.88,0,1.32,0,.07.01.09.09.07.13-.03.26-.07.38-.12.52-.21.98-.71.91-1.46-.03-.3-.15-\
							.56-.4-.75-.27-.21-.57-.34-.89-.45-.07-.03-.09-.02-.09.07,0,.44,0,.88,0,1.31h0ZM10.21,6.65v-1.15s0-.08-.07-.07c-\
							.55.09-1.01.55-1.06,1.1-.04.44.1.81.5,1.05.17.1.35.19.54.26.07.03.09.02.09-.06,0-.38,0-.76,0-1.14h0Z"
						/>
					</g>
				</g>
			</g>
		</SvgIcon>
	);
};

export const FilterListIcon = () => {
	return (
		<SvgIcon className="m-auto relative top-[3px] left-[3px]" fill="none" xmlns="http://www.w3.org/2000/SvgIcon">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d={
					"M6.24518 1.60999C4.59518 1.60999 3.26514 2.94 3.26514 4.59C3.26514 6.24 4.59518 7.57001 6.24518 7.57001C7.89518 7.57001 9.22516 " +
					"6.24 9.22516 4.59C9.22516 2.94 7.89518 1.60999 6.24518 1.60999ZM1.87518 3.62C2.31518 1.61 4.10518 0.109985 6.24518 0.109985C8.38518 " +
					"0.109985 10.1752 1.61 10.6152 3.62H16.1152C16.5252 3.62 16.8652 3.96 16.8652 4.37C16.8652 4.77999 16.5252 5.12 16.1152 " +
					"5.12H10.6951C10.4351 7.34 8.54518 9.07001 6.24518 9.07001C3.94518 9.07001 2.05517 7.35 1.79517 5.12H0.755127C0.345127 5.12 " +
					"0.00512695 4.77999 0.00512695 4.37C0.00512695 3.96 0.345127 3.62 0.755127 3.62H1.86517H1.87518ZM10.6351 12.65C8.98513 12.65 7.65515 " +
					"13.98 7.65515 15.63C7.65515 17.28 8.98513 18.61 10.6351 18.61C12.2851 18.61 13.6152 17.28 13.6152 15.63C13.6152 13.98 12.2851 12.65 " +
					"10.6351 12.65ZM6.18518 15.1C6.44518 12.88 8.33513 11.15 10.6351 11.15C12.9351 11.15 14.8251 12.87 15.0851 15.1H16.1252C16.5352 15.1 " +
					"16.8752 15.44 16.8752 15.85C16.8752 16.26 16.5352 16.6 16.1252 16.6H15.0151C14.5751 18.61 12.7851 20.11 10.6451 20.11C8.50514 20.11 " +
					"6.71515 18.61 6.27515 16.6H0.775146C0.365146 16.6 0.0251465 16.26 0.0251465 15.85C0.0251465 15.44 0.365146 15.1 0.775146 15.1H6.19513H6.18518Z"
				}
				fill="#666666"
			/>
		</SvgIcon>
	);
};

export const SearchOnIcon = () => {
	return (
		<SvgIcon className="m-auto relative top-[3px] left-[3px]" fill="none" xmlns="http://www.w3.org/2000/SvgIcon">
			<path
				d={
					"M13.2153 11.7526C15.6053 8.4926 14.8952 3.9226 11.6352 1.5326C8.37519 -0.857404 3.80522 -0.147387 1.41522 3.11261C-0.974784 " +
					"6.37261 -0.264827 10.9426 2.99517 13.3326C5.56517 15.2226 9.0752 15.2226 11.6452 13.3326C11.6452 13.3326 11.7152 13.4226 11.7552 " +
					"13.4626L16.0853 17.7926C16.5253 18.2326 17.2352 18.2326 17.6752 17.7926C18.1152 17.3526 18.1152 16.6426 17.6752 16.2026L13.3453 " +
					"11.8726C13.3453 11.8726 13.2653 11.7926 13.2153 11.7626V11.7526ZM13.5052 7.42261C13.5052 10.8426 10.7352 13.6126 7.31524 " +
					"13.6126C3.89524 13.6126 1.12518 10.8426 1.12518 7.42261C1.12518 4.00261 3.89524 1.23261 7.31524 1.23261C10.7352 1.23261 " +
					"13.5052 4.00261 13.5052 7.42261Z"
				}
				fill="#666666"
			/>
		</SvgIcon>
	);
};

export const SearchOffIcon = () => {
	return (
		<SvgIcon className="m-auto relative top-[3px] left-[1px]" fill="none" xmlns="http://www.w3.org/2000/SvgIcon">
			<path
				d={
					"M19.95,16.09l-4.33-4.34s-.09-.07-.13-.11c2.38-3.25,1.68-7.83-1.58-10.22S6.08-.26,3.69,3c-.75,1.02-1.2," +
					"2.17-1.35,3.35.22-.03.44-.04.66-.04.17,0,.33.01.49.03.46-2.96,3.01-5.21,6.1-5.21,3.42,0,6.19,2.77,6.19," +
					"6.19s-2.77,6.19-6.19,6.19c-.44,0-.87-.05-1.28-.14-.1.37-.24.72-.42,1.06,2.04.49,4.25.08,6.02-1.21.04.04.07.08.11.13l4.34," +
					"4.33c.43.44,1.15.44,1.59,0s.44-1.15,0-1.59Z"
				}
			/>
			<path
				d={
					"M3.64,11.83l2.23-2.23c.17-.17.17-.46,0-.64-.18-.18-.46-.18-.64,0l-2.23,2.22-2.23-2.23c-.18-.18-.46-.18-.64,0-.18.18-.18.46," +
					"0,.64l2.23,2.23L.13,14.06c-.18.18-.18.46,0,.64.18.18.46.18.64,0l2.23-2.23,2.23,2.23c.18.18.46.18.64,0,.18-.18.18-.46,0-.64l-2.23-2.23Z"
				}
			/>
		</SvgIcon>
	);
};
